import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForOrder,
    withUpdateOrder,
} from "src/modules/order/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateOrder } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await updateOrder(values);
        router.push("/order");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
        />
    );
};

export default compose(withHookForOrder, withUpdateOrder)(Edit);
